import {
  CONTRACT_TYPE,
  CONTRACT_ROLE,
  CONTRACT_CATEGORY,
  CONTRACT_STATUS
} from '../constants'

export const getters = {
  // Module metadata is stored in root state.
  //
  view (state) {
    return state.view
  },
  newContractMetadata (state) {
    return state.newContractMetadata
  },
  newContract (state) {
    return state.newContract
  },
  newContractPeriod (state) {
    return state.newContractPeriod || {}
  },
  newContractParties (state) {
    return state.newContractParties || []
  },
  addContact (state) {
    return !!state.addContact
  },
  contract: (state) => {
    return state.contract
  },
  roleOptions (state, getters, rootState) {
    return rootState.metadata[CONTRACT_ROLE] || []
  },
  contractSearch (state) {
    return state.contractSearch
  },
  requirements (state) {
    return state.requirements
  }
}
